import * as ObjectUtils from "@/utils/object";

export const setPageTitle = (to:any, from:any, next:any) => {
	let title = ObjectUtils.getDeepProperty(to, "meta.title", null);
	if(title){ document.title = title; }
	next();
};